<template>
<div>
  <el-row type="flex" class="title-bar" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
    <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad"/>
  </el-row>
  <el-row>
    <h4 class="title-bar">DISK 성능</h4>
    <el-table-wrapper v-loading="isLoading" :column-default="columnDefault" class="mr-b30" :data="diskList" :columns="columns['DISK']" :show-custom-header="true" :show-search-tool="false" :pagination="false">
      <template slot-scope="scope" slot="disk-userate-slot">
        <el-progress v-if="scope.row['DISK/DISK_USERATE'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['DISK/DISK_USERATE'])"></el-progress>
        <span v-else> - </span>
      </template>
    </el-table-wrapper>
    <h4 class="title-bar">CPU 성능</h4>
    <el-table-wrapper v-loading="isLoading" :column-default="columnDefault" class="mr-b30" :data="cpuList" :columns="columns['CPU']" :show-custom-header="true" :show-search-tool="false" :pagination="false">
      <template slot-scope="scope" slot="cpu-total-userate-slot">
        <el-progress v-if="scope.row['CPU/TOTAL_USERATE'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['CPU/TOTAL_USERATE'])"></el-progress>
        <span v-else> - </span>
      </template>
      <template slot-scope="scope" slot="cpu-sys-userate-slot">
        <el-progress v-if="scope.row['CPU/SYS_USERATE'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['CPU/SYS_USERATE'])"></el-progress>
        <span v-else> - </span>
      </template>
      <template slot-scope="scope" slot="cpu-user-userate-slot">
        <el-progress v-if="scope.row['CPU/USER_USERATE'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['CPU/USER_USERATE'])"></el-progress>
        <span v-else> - </span>
      </template>
      <template slot-scope="scope" slot="cpu-loadavg-1m-slot">
        <el-progress v-if="scope.row['CPU/LOADAVG_1M'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['CPU/LOADAVG_1M'])"></el-progress>
        <span v-else> - </span>
      </template>
      <template slot-scope="scope" slot="cpu-loadavg-5m-slot">
        <el-progress v-if="scope.row['CPU/LOADAVG_5M'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['CPU/LOADAVG_5M'])"></el-progress>
        <span v-else> - </span>
      </template>
      <template slot-scope="scope" slot="cpu-loadavg-15m-slot">
        <el-progress v-if="scope.row['CPU/LOADAVG_15M'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['CPU/LOADAVG_15M'])"></el-progress>
        <span v-else> - </span>
      </template>
    </el-table-wrapper>
    <h4 class="title-bar">메모리 성능</h4>
    <el-table-wrapper v-loading="isLoading" :column-default="columnDefault" border :data="memoryList" :columns="columns['MEMORY']" :show-custom-header="true" :show-search-tool="false" :pagination="false">
      <template slot-scope="scope" slot="mem-phy-userate-slot">
        <el-progress v-if="scope.row['MEM_PHY/USERATE'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['MEM_PHY/USERATE'])"></el-progress>
        <span v-else> - </span>
      </template>
      <template slot-scope="scope" slot="mem-swp-userate-slot">
        <el-progress v-if="scope.row['MEM_SWP/USERATE'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['MEM_SWP/USERATE'])"></el-progress>
        <span v-else> - </span>
      </template>
    </el-table-wrapper>
  </el-row>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import { convertValuByUnit } from '@/utils/number';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import { analysisTimeType } from '@/constants/performance';
import msgUtil from '@/utils/message';
import databaseTableInfoAPI from '@/api/performance/database/database-table-info';
import AnalysisTableMixin from '@/mixins/performance/analysis-table-ex';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';

export default {
  name: 'WHostPerformance',
  mixins: [AnalysisTableMixin],
  components: {
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      checkDatetime: null,
      diskList: [],
      cpuList: [],
      memoryList: [],
      isLoading: false,
      columnDefault,
      columns: {
        DISK: [
          { prop: 'rscKeyName', label: '파티션 명', headerAlign: 'center', sortable: true },
          { label: '디스크 현황',
            headerAlign: 'center',
            childColumns: [
              { prop: 'DISK/DISK_USERATE', label: '사용률(%)', sortable: true, align: 'center', scopedSlot: 'disk-userate-slot' },
              { prop: 'DISK/DISK_TOTSIZE', label: '전체', sortable: true, headerAlign: 'center', formatter: this.convertKValue },
              { prop: 'DISK/DISK_USEDSIZE', label: '사용량', sortable: true, headerAlign: 'center', formatter: this.convertKValue },
              { prop: 'DISK/DISK_AVSIZE', label: '가용량', sortable: true, headerAlign: 'center', formatter: this.convertKValue },
            ] },
        ],
        CPU: [
          { prop: 'rscKeyName', label: 'CPU', headerAlign: 'center', sortable: true, formatter: this.getTableValueAfterCheckEmpty },
          { label: 'CPU사용률(%)',
            headerAlign: 'center',
            childColumns: [
              { prop: 'CPU/TOTAL_USERATE', label: '전체 사용률', sortable: true, align: 'center', scopedSlot: 'cpu-total-userate-slot' },
              { prop: 'CPU/SYS_USERATE', label: '시스템 사용률', sortable: true, align: 'center', scopedSlot: 'cpu-sys-userate-slot' },
              { prop: 'CPU/USER_USERATE', label: '사용자 사용률', sortable: true, align: 'center', scopedSlot: 'cpu-user-userate-slot' },
            ] },
          { label: '부하평균(%)',
            headerAlign: 'center',
            childColumns: [
              { prop: 'CPU/LOADAVG_1M', label: '1분 부하평균', sortable: true, align: 'center', scopedSlot: 'cpu-loadavg-1m-slot' },
              { prop: 'CPU/LOADAVG_5M', label: '5분 부하평균', sortable: true, align: 'center', scopedSlot: 'cpu-loadavg-5m-slot' },
              { prop: 'CPU/LOADAVG_15M', label: '15분 부하평균', sortable: true, align: 'center', scopedSlot: 'cpu-loadavg-15m-slot' },
            ] },
        ],
        MEMORY: [
          { prop: 'rscKeyName', label: '메모리', headerAlign: 'center', sortable: true, formatter: this.getTableValueAfterCheckEmpty },
          { label: '물리메모리 현황 (byte)',
            headerAlign: 'center',
            childColumns: [
              { prop: 'MEM_PHY/TOTSIZE', label: '전체', sortable: true, headerAlign: 'center', formatter: this.convertKValue },
              { prop: 'MEM_PHY/USEDSIZE', label: '사용량', sortable: true, headerAlign: 'center', formatter: this.convertKValue },
              { prop: 'MEM_PHY/AVSIZE', label: '가용량', sortable: true, headerAlign: 'center', formatter: this.convertKValue },
              { prop: 'MEM_PHY/USERATE', label: '사용률(%)', sortable: true, align: 'center', scopedSlot: 'mem-phy-userate-slot' },
            ] },
          { label: '스왑메모리 현황 (byte)',
            headerAlign: 'center',
            childColumns: [
              { prop: 'MEM_SWP/TOTSIZE', label: '전체', sortable: true, headerAlign: 'center', formatter: this.convertKValue },
              { prop: 'MEM_SWP/USEDSIZE', label: '사용량', sortable: true, headerAlign: 'center', formatter: this.convertKValue },
              { prop: 'MEM_SWP/AVSIZE', label: '가용량', sortable: true, headerAlign: 'center', formatter: this.convertKValue },
              { prop: 'MEM_SWP/USERATE', label: '사용률(%)', sortable: true, align: 'center', scopedSlot: 'mem-swp-userate-slot' },
            ] },
        ],
      },
    };
  },
  methods: {
    /**
     * 데이터를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      const params = {
        objId: this.selectedNode.obj.objId,
      };
      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        this.isLoading = true;
        databaseTableInfoAPI.getCurrenthostPerformanceList(params).then((result) => {
          if (result.data.success) {
            const data = result.data.data;
            this.cpuList = data.CPU;
            this.diskList = data.DISK;
            this.memoryList = data.MEM;
          } else {
            this.failToLoadData();
          }
        }).catch(() => {
          this.failToLoadData();
        }).finally(() => {
          this.isLoading = false;
        });
      } else {
        params.baselineDatetime = this.plotLineDatetime;
        this.isLoading = true;
        databaseTableInfoAPI.getHostPerformanceList(params).then((result) => {
          if (result.data.success) {
            const data = result.data.data;
            this.cpuList = data.CPU.snapshotDoc;
            this.diskList = data.DISK.snapshotDoc;
            this.memoryList = data.MEM.snapshotDoc;
            this.checkDatetime = data.CPU.timestamp;
          } else {
            this.failToLoadData();
          }
        }).catch(() => {
          this.failToLoadData();
        }).finally(() => {
          this.isLoading = false;
        });
      }
    },
    /**
     * 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadData() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'HOST 성능 정보', false));
    },
    /**
     * [getPercentage 프로그래스바 * 100]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getPercentage(value) {
      return isNil(value) ? 0 : value;
    },
    /**
     * [unitFormatter 컬럼이 비었을 경우 -로 표시, 단위 표시]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    convertKValue(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return Number(value) === 0 ? 0 : convertValuByUnit(value, 'KB', true, true, true);
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>

<style module>
.host-performance-header {
  height: 50px;
  background-color: #f1f1f1;
  line-height: 3;
}
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/components/table/HostPerformance.vue